/*
  Celia Moda Premium Cart Drawer
  Part 3 — Ajax cart + drawer control
*/

(function () {
  const drawer = document.querySelector('[data-celia-cart]');
  if (!drawer) return;

  const cartItems = drawer.querySelector('[data-celia-cart-items]');
  const cartTotal = drawer.querySelector('[data-celia-cart-total]');
  const shippingText = drawer.querySelector('[data-celia-shipping-text]');
  const shippingProgress = drawer.querySelector('[data-celia-shipping-progress]');
  const threshold = Number(drawer.dataset.freeShippingThreshold || 0);

  function money(cents) {
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: Shopify.currency.active || 'USD'
    });
  }

  function openCart() {
    drawer.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeCart() {
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  window.CeliaCartOpen = openCart;
  window.CeliaCartClose = closeCart;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-celia-cart-close]')) {
      closeCart();
    }

    const cartLink = e.target.closest('a[href="/cart"], a[href*="/cart"]');
    if (cartLink && !cartLink.closest('.celia-cart')) {
      e.preventDefault();
      openCart();
    }
  });

  function updateShipping(cart) {
    if (!shippingText || !shippingProgress || !threshold) return;

    const total = cart.total_price;
    const percent = Math.min((total / threshold) * 100, 100);
    shippingProgress.style.width = percent + '%';

    if (total >= threshold) {
      shippingText.textContent = 'You unlocked free shipping.';
    } else {
      shippingText.textContent = 'Spend ' + money(threshold - total) + ' more for free shipping.';
    }
  }

  function renderCart(cart) {
    if (cartTotal) cartTotal.textContent = money(cart.total_price);
    updateShipping(cart);

    if (!cartItems) return;

    if (cart.item_count === 0) {
      cartItems.innerHTML = `
        <div class="celia-cart__empty">
          <h3>Your bag is empty</h3>
          <p>Discover Celia Moda’s newest arrivals.</p>
          <a href="/collections/all" class="celia-cart__empty-button">Shop New Arrivals</a>
        </div>
      `;
      return;
    }

    cartItems.innerHTML = cart.items.map((item, index) => {
      const image = item.image ? item.image : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="celia-cart__variant">${item.variant_title}</div>`
        : '';

      return `
        <div class="celia-cart__item" data-celia-cart-item data-line="${index + 1}">
          <a href="${item.url}" class="celia-cart__item-image">
            <img src="${image}" alt="${item.product_title}" loading="lazy">
          </a>

          <div class="celia-cart__item-info">
            <div>
              <div class="celia-cart__item-top">
                <a href="${item.url}" class="celia-cart__item-title">${item.product_title}</a>
                <button type="button" class="celia-cart__remove" data-celia-remove data-line="${index + 1}">×</button>
              </div>
              ${variant}
            </div>

            <div class="celia-cart__item-bottom">
              <div class="celia-cart__qty">
                <button type="button" data-celia-qty-minus data-line="${index + 1}">−</button>
                <input type="number" value="${item.quantity}" min="0" data-celia-qty-input data-line="${index + 1}">
                <button type="button" data-celia-qty-plus data-line="${index + 1}">+</button>
              </div>

              <div class="celia-cart__price">${money(item.final_line_price)}</div>
            </div>
          </div>
        </div>
      `;
    }).join('');
  }

  function getCart() {
    return fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        renderCart(cart);
        return cart;
      });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity })
    })
      .then(res => res.json())
      .then(renderCart);
  }

  drawer.addEventListener('click', function (e) {
    const remove = e.target.closest('[data-celia-remove]');
    if (remove) {
      changeLine(Number(remove.dataset.line), 0);
      return;
    }

    const minus = e.target.closest('[data-celia-qty-minus]');
    if (minus) {
      const input = drawer.querySelector(`[data-celia-qty-input][data-line="${minus.dataset.line}"]`);
      const newQty = Math.max(Number(input.value) - 1, 0);
      changeLine(Number(minus.dataset.line), newQty);
      return;
    }

    const plus = e.target.closest('[data-celia-qty-plus]');
    if (plus) {
      const input = drawer.querySelector(`[data-celia-qty-input][data-line="${plus.dataset.line}"]`);
      const newQty = Number(input.value) + 1;
      changeLine(Number(plus.dataset.line), newQty);
      return;
    }

    const upsell = e.target.closest('[data-celia-add-upsell]');
    if (upsell) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: Number(upsell.dataset.variantId),
          quantity: 1
        })
      }).then(() => getCart());
    }

    const discount = e.target.closest('[data-celia-apply-discount]');
    if (discount) {
      const input = drawer.querySelector('[data-celia-discount-input]');
      if (input && input.value.trim()) {
        window.location.href = '/discount/' + encodeURIComponent(input.value.trim()) + '?redirect=/cart';
      }
    }
  });

  drawer.addEventListener('change', function (e) {
    const input = e.target.closest('[data-celia-qty-input]');
    if (!input) return;

    changeLine(Number(input.dataset.line), Math.max(Number(input.value), 0));
  });

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    e.preventDefault();

    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(() => getCart())
      .then(() => openCart());
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  getCart();
})();